var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemCursosIconFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.34 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.4,3.34c-.62-.35-1.26-.68-1.91-1A25.78,25.78,0,0,0,9.39.89,24,24,0,0,0,.69.11.77.77,0,0,0,0,.88V24a.82.82,0,0,0,.24.57.8.8,0,0,0,.59.19,23.83,23.83,0,0,1,7.76.55A27.44,27.44,0,0,1,15.4,28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.65.11A24.12,24.12,0,0,0,23,.88a27.08,27.08,0,0,0-4.12,1.49c-.64.29-1.28.62-1.91,1V28a27,27,0,0,1,6.82-2.65,23.77,23.77,0,0,1,7.75-.55.77.77,0,0,0,.59-.19.79.79,0,0,0,.25-.57V.88A.77.77,0,0,0,31.65.11Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemCursosIconFill);
export default __webpack_public_path__ + "static/media/item_cursos_icon_fill.17cff30f957ab984bc26b388a0122afe.svg";
export { ForwardRef as ReactComponent };